<div class="project-component" style="margin-top: 20px;">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">

  </div>
  <div style="display: flex; flex-direction: row;" [ngStyle]="{ gap: collapsed ? '0': '40px' }">
    <div style="display: flex; flex-direction: column; margin-left: 40px;position:relative; padding-top: 30px;" [ngStyle]="{flex: collapsed ? '0 0 30px': '0 0 200px'}"
         class="list">
      <div style="position: absolute; top:10px; right: 10px;" (click)="collapsed = !collapsed">
        <i [class]="collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
      </div>
      <div *ngIf="!collapsed" style="margin-left: 30px">
        <h3>Mappings</h3>
        <div *ngFor="let mapping of mappingTemplates" style="white-space: nowrap; display: flex; flex-direction: row;">
          <a style="display: inline-block;text-overflow: ellipsis;width: 100%;overflow:hidden; flex:0 1 auto"
             pTooltip="{{mapping.name}}{{'\r\n'}}Updated on {{mapping.modifiedDate | date:'shortDate'}}" (click)="selectedMappingTemplate = mapping; mappingTemplateId = mapping.mappingTemplateId;loadMappingItems(mapping.mappingTemplateId)"
             class="training-link" routerLinkActive="active">{{mapping.name || "Default"}}</a>
        </div>
        <div style="margin-left: 10px;">
          <a (click)="createMappingTemplate()">
            <div class="fa fa-plus"></div>
          </a>
        </div>
      </div>
    </div>
    <div style="width: calc(100% - 300px);" *ngIf="selectedMappingTemplate">
      <mat-form-field style="width: 50%; margin-right: 10px">
        <input matInput [(ngModel)]="selectedMappingTemplate.name"/>
      </mat-form-field>
      <button mat-raised-button
              (click)="saveMapping()">
        Save
      </button>
      <span class="icon-delete" (click)="deleteMapping()"></span>

      <button mat-raised-button [matMenuTriggerFor]="appMenu"
              style="border-radius: 6px;margin-right: 10px;white-space: nowrap;float:right;"
              class="button">
        Actions<span class="mat-select-arrow"
                     style="display:inline-block; width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid;margin: 0 4px;"></span>
      </button>
      <mat-menu #appMenu="matMenu">
        <button mat-menu-item
                (click)="inputFile.click()" >
          <i class="pi pi-paperclip"></i>
          Upload Mapping
        </button>
        <a mat-menu-item
                href="{{api}}/api/mapping/{{mappingTemplateId}}/export?token={{token}}">
          Download Mapping Template
        </a>
      <input #inputFile
             type="file"
             (change)="uploadMapping($event)"
             [style.display]="'none'">
      </mat-menu>


      <p-table
                [value]="mappingItems">

                <ng-template pTemplate="header">
                  <tr style="white-space: nowrap;font-weight: bold">
                    <th *ngFor="let col of cols" [pSortableColumn]="col.field"
                        [ngStyle]="{'width': col.width || 'auto'}">
                      {{col.header}}
                    </th>
                    <th style="width:15em"></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr [pSelectableRow]="item">
                    <td>{{item.fromComplianceAreaName}}</td>
                    <td>{{item.fromControlItemName}}</td>
                    <td>{{item.toComplianceAreaName}}</td>
                    <td>{{item.toControlItemName}}</td>
                    <td>{{item.isPrimary?'Primary' : 'Secondary'}}</td>
                    <td>
                      <button type="button" pButton class="risksponge-button" (click)="removeMappingItem(item)"
                              icon="pi pi-trash"></button>
                    </td>

                  </tr>
                  <tr [pSelectableRow]="item" (click)="item.hidden = !item.hidden">
                    <div class="component-detail-btn">
                      <p>Mapping Details</p>
                      <i [ngClass]="item.hidden ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                    </div>
                  </tr>
                  <tr  [pSelectableRow]="item" [@expandCollapse]="item.hidden ? 'expanded' : 'collapsed'">
                    <td style="vertical-align: top;">
                      <h3 class="detail-heading">Implementation</h3>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.ics1" disabled></mat-checkbox>
                        <p>ICS1</p>

                      </div>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.ics2" disabled></mat-checkbox>
                        <p>ICS2</p>
                      </div>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.ics3" disabled></mat-checkbox>
                        <p>ICS3</p>
                      </div>
                      <!-- <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.implementationControlStatement" disabled></mat-checkbox>
                        <p>Implementation Control Statement</p>
                      </div> -->
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.controlsTesting" disabled></mat-checkbox>
                        <p>Controls Testing</p>
                      </div>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.inheritedControls" disabled></mat-checkbox>
                        <p>Inherited Controls</p>

                      </div>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.gaps" disabled></mat-checkbox>
                        <p>Gaps</p>

                      </div>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.workstream" disabled></mat-checkbox>
                        <p>Workstream</p>

                      </div>

                      <h3 class="detail-heading">Artifacts & Evidence</h3>
                      <div class="detail-div">
                        <mat-checkbox class="mapping-checkboxes" [checked]="item.evidence" disabled></mat-checkbox>
                        <p>Evidence</p>

                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.policy" disabled></mat-checkbox>
                        <p>Policy</p>
                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.documentation" disabled></mat-checkbox>
                        <p>Documentation</p>
                      </div>
                    </td>
                    <td style="vertical-align: top;">
                      <h3 class="detail-heading">Assessment</h3>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.intAssessment" disabled></mat-checkbox>
                        <p>Int Assessment</p>
                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.thirdPartySecurity" disabled></mat-checkbox>
                        <p>3P Security</p>
                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.thirdPartyRisk" disabled></mat-checkbox>
                        <p>3P Risk</p>
                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.areaSpecific" disabled></mat-checkbox>
                        <p>Area Specific</p>
                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.scoring" disabled></mat-checkbox>
                        <p>Scoring</p>
                      </div>
                      <h3 class="detail-heading">NIST FedRAMP</h3>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.organizationalParameters" disabled></mat-checkbox>
                        <p>Organizational Parameters</p>
                      </div>
                      <div class="detail-div">

                        <mat-checkbox class="mapping-checkboxes" [checked]="item.controlOrigination" disabled></mat-checkbox>
                        <p>Control Origination</p>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </ng-template>
              </p-table>
          <!--span class="pi pi-plus"
                (click)="mappingItems.push({editMode: true, mappingTemplateId: mappingTemplateId})"></span-->
    </div>

  </div>
</div>
